import { MDBContainer, MDBSpinner } from "mdb-react-ui-kit";
import { size } from "mdb-react-ui-kit/dist/types/types/size";
import { CSSProperties } from "react";

export interface LoadingSpinnerProps {
    size?: size;
    className?: string;
    style?: CSSProperties;
    noFull?: boolean;
}

export const LoadingSpinner = ({size, className, style, noFull}: LoadingSpinnerProps) => (
    <MDBContainer style={style} className={"d-flex justify-content-center align-items-center " + (noFull ? "" : "h-100 w-100 ") + className}>
        <MDBSpinner role="status" size={size}>
            <span className="visually-hidden">Loading...</span>
        </MDBSpinner>
    </MDBContainer>
)